import { formatThousands } from "lib/numberFormat";
import { getQueryString } from "lib/routing";
import { toArray } from "lib/utils";
import { push, resetToFirstPage } from "api/search/filterUrlMaker";
import React from "react";
import { Form } from "react-bootstrap";

export function Suggestion({ label, count, isSelected, type = "checkbox", onClick, id, className = "d-block" }, index) {
  return (
    <Form.Check
      key={label + index + isSelected}
      id={id || label + count}
      type={type}
      label={
        <span>
          {label} <small>{formatCount(count)}</small>
        </span>
      }
      className={(isSelected && "text-primary ") + className}
      checked={isSelected}
      onChange={onClick}
    />
  );
}

export const toggleQueryParam = (param, value, qs = getQueryString()) => {
  const selectedItems = toArray(qs[param]);
  if (selectedItems.includes(value)) {
    qs[param] = selectedItems.filter((item) => item !== value);
  } else {
    qs[param] = [...selectedItems, value];
  }
  push(resetToFirstPage(qs));
};

export const toggleQueryParams = (value, qs = getQueryString(), param) => {
  const qsKey = findKeyOfQsValue(value, qs);

  if (qsKey) {
    qs[qsKey] = removeValue(qsKey, value, qs);
  } else {
    qs[param] = [...toArray(qs[param]), value];
  }
  push(resetToFirstPage(qs));
};

export const setQueryParam = (param, suggestion, qs = getQueryString()) => {
  qs[param] = suggestion;
  push(resetToFirstPage(qs));
};

export const formatCount = (nCount) => (nCount ? ` (${formatThousands(nCount)})` : "");
const findKeyOfQsValue = (value, qs) => Object.keys(qs).find((key) => toArray(qs[key]).includes(value));

const removeValue = (key, value, qs) => toArray(qs[key] || []).filter((item) => item !== value);

export const toggleQueryParamsCountry = (value, qs = getQueryString(), param, checked = false) => {
  const qsKey = findKeyOfQsValue(value, qs);
  if (qsKey && checked === false) {
    ["countries.en", "countries.ja", "Country-JA", "Country", "countries"].forEach((key) => {
      if (toArray(qs[key]).includes(value)) {
        qs[key] = removeValue(key, value, qs);
      }
    });
  } else if (checked === true) {
    qs[param] = [...toArray(qs[param]), value];
  }
  push(resetToFirstPage(qs));
};

export const toggleQueryParamsRegion = (value, qs = getQueryString(), param, checked = false) => {
  const newQs = { ...qs };

  if (checked === true) {
    newQs[param] = [...toArray(newQs[param]), value];
  } else {
    ["regions.en", "regions.ja", "regions", "Region", "Region-JA"].forEach((key) => {
      if (toArray(newQs[key]).includes(value)) {
        newQs[key] = removeValue(key, value, newQs);
      }
    });
  }

  push(resetToFirstPage(newQs));
};
